import axios from 'axios';
import { BACKEND_URL } from '../utils/backendUrl';

const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with defaults
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Nexus API endpoints
export const nexusApi = {
  // Health & Governance
  health: () => api.get('/nexus/health'),
  governance: () => api.get('/nexus/governance'),

  // Content Studio
  contentContext: (data) => api.post('/studio/content/context', data),
  contentPrecheck: (data) => api.post('/studio/content/precheck', data),
  contentPostcheck: (data) => api.post('/studio/content/postcheck', data),

  // Live Studio (Phase 2)
  livePlan: (data) => api.post('/studio/live/plan', data),
  liveScriptGenerate: (data) => api.post('/studio/live/script/generate', data),
  liveASRMonitor: (data) => api.post('/studio/live/asr/monitor', data),
  liveReport: (data) => api.post('/studio/live/report', data),

  // Copywriting Studio (Phase 2)
  copyAnalyze: (data) => api.post('/studio/copy/analyze', data),
  copyGenerate: (data) => api.post('/studio/copy/generate', data),
  copyExport: (data) => api.post('/studio/copy/export', data),

  // Analyst Studio (Phase 2)
  analystAnalyze: (data) => api.post('/studio/analyst/analyze', data),
  analystInsightGenerate: (data) => api.post('/studio/analyst/insight/generate', data),
  analystInsightApprove: (data) => api.post('/studio/analyst/insight/approve', data),
  analystTrendsLibrary: () => api.get('/studio/analyst/trends/library'),

  // Brain System
  updateBP: (data) => api.post('/brain/bp/update', data),
  getScorecard: (userId) => api.get(`/brain/scorecard/${userId}`),

  // Auth (mock for now - will be implemented in backend)
  login: (credentials) => {
    // Mock login for demonstration
    return Promise.resolve({
      data: {
        user_id: 'USR_DEMO_001',
        role: 'executor',
        name: 'Demo User',
        level: 3,
        total_bp: 450
      }
    });
  },

  register: (userData) => {
    // Mock register
    return Promise.resolve({
      data: {
        user_id: `USR_${Date.now()}`,
        ...userData,
        level: 1,
        total_bp: 0
      }
    });
  }
};

export default api;
